import { render, staticRenderFns } from "./01_Sanierung.vue?vue&type=template&id=6f2d7716&"
import script from "./01_Sanierung.vue?vue&type=script&lang=js&"
export * from "./01_Sanierung.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports